<template>
  <section>
     <form >
          <website ref="website"/>
            <div class="name">
            <div class="page section-header text-center">
              <h1 class="h1">CREATE ACCOUNT</h1>
            </div>
    <div class="p-fluid  p-col-6 p-offset-3">
      <div class="p-field">
        <label for="firstname">First Name</label>
        <InputText id="firstname" type="text"/>
      </div>
      <div class="p-field ">
        <label for="lastname">Last Name</label>
        <InputText id="lastname" type="text"/>
      </div>
      <div class="p-field ">
        <label for="email">Email</label>
        <InputText id="email" type="text"/>
      </div>
      <div class="p-field ">
        <label for="password">Password</label>
        <InputText id="password" type="text"/>
      </div>
      <div class="text-center hover-line">
        <Button label="CREATE" class="btn" style="width: 15%;"/>
      </div>
    </div>
    </div>
    <footerWebsite ref="footerWebsite"/>
     </form>
  </section>
</template>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
export default {
  name: 'UserRegister',
  components: {
    InputText,
    Button,
    website,
    footerWebsite
  }
}
</script>

<style scoped src="@../../../static/css/website.css">

</style>



// WEBPACK FOOTER //
// UserRegister.vue?1f378f5a